export enum IntegrationType {
  Integration = "integration",
  SDK = "sdk",
}
